import {
  vsProviderName as machineDetailTabsProviderName,
  MachineDetailTabsProvider,
} from "../../../../../shared/components/views/machines/detail/tabs";
import { vsComponentName as DecommissionComponentName } from "./decommission";
import { vsComponentName as WarehouseComponentName } from "./warehouse";
import { vsComponentName as MoveComponentName } from "./move";
import { StateParams, StateService } from "@uirouter/angularjs";
import { MachineGateway } from "../../../../models/machine";
import { cloneDeep } from "lodash";
import {
  IMachineEditFormModel,
  vsComponentName as machineEditFormComponentName,
} from "../../../../components/machineEditForm";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../../../records/forms/formView";
import {
  vsName as CloneAndConversionServiceName,
  CloneAndConversionServiceGateway,
} from "../../../../services/cloneAndConversionService";
import { IReportGroup } from "../../../../../../reporting/interfaces/IReportGroup";
import { IScope } from "angular";
import { MachineDetailConfigurationViewArgs } from "../../../../../shared/components/views/machines/detail/views/configurations/controller";

export function machineDetailConfigurationsComponentConfig(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider.addElement({
    id: "configurations",
    displayName: "Configurations",
    order: Number.MIN_SAFE_INTEGER,
    uiSrefFragment: "configurations",
    requiredPermission: "machineView",
    stateDefinition: {
      url: "/configurations",
      template: require("!html-loader!./index.html").default,
      controller: [
        "$scope",
        "machine",
        "reportGroup",
        (
          $scope: IScope,
          machine: MachineGateway,
          reportGroup: IReportGroup
        ) => {
          const s = <any>$scope;
          s.machine = machine;
          s.reportGroup = reportGroup;
          s.editSref = "^.edit";

          s.accordionHeading = (args: MachineDetailConfigurationViewArgs) => {
            const {
              changeIsPending,
              currentConfiguration,
              dateString,
              machineConfiguration,
            } = args;
            const futureChange = changeIsPending;

            return `${machineConfiguration.ChangeType} - ${dateString}${
              currentConfiguration && !futureChange ? " - Current" : ""
            }${futureChange ? " - Pending" : ""}`;
          };
        },
      ],
    },
    children: [
      {
        id: "decommission",
        displayName: "Decommission",
        uiSrefFragment: "decommission",
        // stateDefinition: {
        //   component: DecommissionComponentName,
        //   url: "/decommission",
        //   resolve: {
        //     machine: ["machine", (machine: any) => machine],
        //   },
        //   bindings: {
        //     machine: "machine",
        //   },
        // },
      },
      {
        id: "warehouse",
        displayName: "Warehouse",
        uiSrefFragment: "warehouse",
        // stateDefinition: {
        //   component: WarehouseComponentName,
        //   url: "/warehouse",
        //   resolve: {
        //     machine: ["machine", (machine: any) => machine],
        //   },
        //   bindings: {
        //     machine: "machine",
        //   },
        // },
      },
      {
        id: "move",
        displayName: "Move",
        uiSrefFragment: "move",
        // stateDefinition: {
        //   component: MoveComponentName,
        //   url: "/move",
        //   resolve: {
        //     machine: ["machine", (machine: any) => machine],
        //   },
        //   bindings: {
        //     machine: "machine",
        //   },
        // },
      },
      {
        id: "conversion",
        displayName: "Conversion",
        uiSrefFragment: "conversion",
        // stateDefinition: {
        //   url: "/conversion",
        //   component: machineEditFormComponentName,
        //   params: {
        //     modelMachineConfigurationId: undefined,
        //     modelMachineId: undefined,
        //   },
        //   resolve: {
        //     model: [
        //       "machine",
        //       "$stateParams",
        //       CloneAndConversionServiceName,
        //       (
        //         machine: MachineGateway,
        //         $stateParams: StateParams,
        //         cloneAndConversionService: CloneAndConversionServiceGateway
        //       ) => {
        //         let modelMachineId: number | undefined =
        //           $stateParams.modelMachineId;
        //         let modelMachineConfigurationId: number | undefined =
        //           $stateParams.modelMachineConfigurationId;

        //         const currentConfiguration = machine.Configs!.find(
        //           (c) => c.CurrentConfiguration
        //         )!;

        //         if (
        //           modelMachineConfigurationId == undefined &&
        //           modelMachineConfigurationId !== undefined
        //         )
        //           throw new Error(
        //             "Must provide model machine configuration id"
        //           );

        //         const modelMachine = cloneDeep(machine ?? {});
        //         delete modelMachine.Configs;

        //         return cloneAndConversionService
        //           .getConversionConfiguration(
        //             currentConfiguration,
        //             modelMachineId,
        //             modelMachineConfigurationId
        //           )
        //           .then((conversionConfiguration) => {
        //             return {
        //               Machine: modelMachine,
        //               Configuration: conversionConfiguration,
        //             };
        //           });
        //       },
        //     ],
        //     progressiveDefinition: [
        //       "model",
        //       CloneAndConversionServiceName,
        //       (
        //         model: IMachineEditFormModel,
        //         cloneAndConversionService: CloneAndConversionServiceGateway
        //       ) =>
        //         cloneAndConversionService.getProgressiveDefinition(
        //           model.Configuration.ProgressiveDefinitionId
        //         ),
        //     ],
        //     machineFieldsEditable: [() => false],
        //     onSubmit: [
        //       FormViewServiceName,
        //       "$state",
        //       (formViewService: FormViewService, $state: StateService) =>
        //         (
        //           formViewController: FormViewController,
        //           model: IMachineEditFormModel
        //         ) =>
        //           formViewService
        //             .submitForm({
        //               url: `/api/machines/${model.Machine.Id}/conversion`,
        //               method: "post",
        //               formObject: model.Configuration,
        //               formViewController,
        //               validationPrefix: "Configuration",
        //             })
        //             .then((result: unknown) =>
        //               $state.go("^", undefined, { reload: true })
        //             ),
        //     ],
        //     onCancel: [
        //       "$state",
        //       ($state: StateService) => () => $state.go("^"),
        //     ],
        //     formTitle: [() => "Convert Machine"],
        //   },
        // },
      },
    ],
  });
}

machineDetailConfigurationsComponentConfig.$inject = [
  machineDetailTabsProviderName,
];
